<div class="row align-items-center">
  @if (kpiInformation?.itemsCount) {
    <div
      class="row with-gap align-items-center hoverable-container"
      id="kpiTooltipIconId"
      (mouseenter)="onHoverableContainerMouseEnter()"
      (mouseleave)="onHoverableContainerMouseLeave()">
      <h2>{{ kpiInformation?.onTargetItemsCount }}/{{ kpiInformation?.itemsCount }}</h2>
      <app-performance-indicator-arrow
        [isBigIcon]="true"
        [isPositive]="kpiInformation?.hasPositivePerformance"
        [isTheSame]="kpiInformation?.hasTheSamePerformance"
      ></app-performance-indicator-arrow>
    </div>
  }
  <dx-tooltip
    target="{{targetId}}"
    [(visible)]="isVisible"
    [hideOnOutsideClick]="true"
    (onHiding)="onHidingTooltip()">
    <dxo-position
      my="left top"
      at="left bottom"
      offset="+5 +5"
      of="#kpiTooltipIconId"
      >
    </dxo-position>
    <div class="column py-1">
      @for (item of kpiInformation.performanceIndicators; track item) {
        <div
          class="row grow justify-space-between kpi-container"
          >
          <div>{{item.name}} ({{item.unitSymbol}}):</div>
          @if (item.calculatedValue !== undefined) {
            <div class="ml-1 value-container">{{item.calculatedValue}}%</div>
          }
          @if (item.calculatedValue === undefined) {
            <div class="ml-1 value-container"> {{ "Shell.generic.na" | translate }}</div>
          }
        </div>
      }
    </div>
  </dx-tooltip>

  @if (!kpiInformation?.itemsCount) {
    <div
      class="row with-gap align-items-center"
      >
      <h2>{{ kpiInformation?.onTargetItemsCount }}/{{ kpiInformation?.itemsCount }}</h2>
      <app-performance-indicator-arrow
        [isBigIcon]="true"
        [isPositive]="kpiInformation?.hasPositivePerformance"
        [isTheSame]="kpiInformation?.hasTheSamePerformance"
      ></app-performance-indicator-arrow>
    </div>
  }
</div>
